module.exports = __webpack_public_path__ + "img/sofitel_header.cec58884.webp";